import { crearIdLector } from "./comicReaderUtils";

const pagesContext = require.context("./pages", true, /\.jsx$/);

const crearEnlaceComic = (info) =>
  info.enlace ||
  `/comic/${info.titulo
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9]/g, "")}`;

const catalogo = pagesContext
  .keys()
  .map((file) => {
    try {
      const modulo = pagesContext(file);
      const info = modulo.infoManga;

      if (!info || typeof modulo.default !== "function") return null;

      return {
        id: crearIdLector(info.titulo),
        info,
        Component: modulo.default,
      };
    } catch (error) {
      console.error("Error creando el catálogo del lector:", file, error);
      return null;
    }
  })
  .filter(Boolean);

export const obtenerComicLocalParaLector = (comicId) => {
  const idBuscado = crearIdLector(decodeURIComponent(comicId || ""));
  const comic = catalogo.find(({ id }) => id === idBuscado);

  if (!comic) return null;

  try {
    // Adaptador para los archivos actuales. Las páginas son componentes simples
    // que devuelven <ComicBase paginas={[...]}> y no utilizan hooks.
    const elemento = comic.Component({});
    const paginas = elemento?.props?.paginas;

    if (!Array.isArray(paginas) || paginas.length === 0) return null;

    return {
      comicId: comic.id,
      titulo: elemento.props.titulo || comic.info.titulo,
      paginas,
      enlace: crearEnlaceComic(comic.info),
    };
  } catch (error) {
    console.error("No se pudieron leer las páginas del cómic:", comicId, error);
    return null;
  }
};

const resolverPaginaManifest = (pagina, baseUrl) => {
  if (typeof pagina !== "string") return null;

  const valor = pagina.trim();
  if (!valor) return null;

  if (/^(https?:)?\/\//i.test(valor) || valor.startsWith("/") || valor.startsWith("data:")) {
    return valor;
  }

  return `${baseUrl}${valor.replace(/^\.\//, "")}`;
};

export const cargarComicDesdeManifest = async (comicId, signal) => {
  const id = crearIdLector(decodeURIComponent(comicId || ""));
  const baseUrl = `/comics/${encodeURIComponent(id)}/`;
  const response = await fetch(`${baseUrl}manifest.json`, { signal });

  if (!response.ok) return null;

  const manifest = await response.json();
  const paginasManifest = manifest.paginas || manifest.pages;

  if (!Array.isArray(paginasManifest)) return null;

  const paginas = paginasManifest
    .map((pagina) => resolverPaginaManifest(pagina, baseUrl))
    .filter(Boolean);

  if (paginas.length === 0) return null;

  return {
    comicId: id,
    titulo: manifest.titulo || manifest.title || id,
    paginas,
    enlace: manifest.enlace || manifest.comicUrl || "/",
  };
};
